import { createRouter } from '@tanstack/react-router';

import { routeTree } from '@/routeTree.gen';

import type { RouterContext } from './route-guards';
import { getRouterContext } from './route-guards';
import { registerRouter } from './router-utils';

export const router = createRouter({
  routeTree,
  context: getRouterContext(),
  defaultPreload: 'intent',
  defaultPreloadStaleTime: 0,
});

// Register router instance for use by updateRouterContext utility
registerRouter(router);

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

export type { RouterContext };

// Re-export for backwards compatibility - prefer importing from router-utils directly
export { updateRouterContext } from './router-utils';
